import { Component } from "react";

// Last line of defence — a render crash shows a calm recovery screen instead of a blank page.
export class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("TRAIDE render error", error, info?.componentStack); }
  componentDidUpdate(prev) { if (this.state.error && prev.location !== this.props.location) this.setState({ error: null }); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex min-h-[60vh] items-center justify-center p-6" data-testid="error-boundary">
        <div className="card max-w-md p-8 text-center">
          <div className="ref t4 text-[11px]">Unexpected error</div>
          <h2 className="h1 mt-2 text-[20px]">This screen hit a snag</h2>
          <p className="t3 mt-2 text-sm">Your data is safe. Reload the screen, or head back to the dashboard and try again.</p>
          <div className="mt-5 flex justify-center gap-2">
            <a href="/" className="btn-secondary btn-sm" data-testid="error-boundary-home">Dashboard</a>
            <button className="btn-primary btn-sm" onClick={() => window.location.reload()} data-testid="error-boundary-reload">Reload</button>
          </div>
        </div>
      </div>
    );
  }
}
